import InstructionalModal from './InstructionalModal';

export default InstructionalModal;
